import { TabBarMenuTabType, TabBarTab } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  shoppingCartCount?: number;
  tabs: TabBarMenuTabType[];
};

export default function TabBarMenu({ shoppingCartCount, tabs }: Props) {
  const styles: CSSProperties = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,

    height: "var(--tabbar-height)",

    backgroundColor: "var(--color-background-tabbar)",
    boxShadow: "inset var(--box-shadow-color) var(--box-shadow-offset)",

    display: "grid",
    gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
    alignItems: "center",

    listStyle: "none",

    padding: "0 var(--spacing-sm)",
  };

  return (
    <ul style={styles}>
      {tabs.map((tab) => (
        <TabBarTab
          key={tab.id}
          shoppingCartCount={shoppingCartCount}
          tab={tab}
        />
      ))}
    </ul>
  );
}
